import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import {StatusBar} from '@awesome-cordova-plugins/status-bar/ngx';
import {Constant} from "../shared/model/Constant";
import {AuthService} from "../service/auth.service";
import {environment} from "../../environments/environment";
import { IntegrationService } from '../service/integration.service';

@Component({
  selector: 'app-report-network',
  templateUrl: './report-network.page.html',
  styleUrls: ['./report-network.page.scss'],
})
export class ReportNetworkPage implements OnInit {

  metabaseUrl: SafeResourceUrl;
  user: any;
  userId: string;
  isAuthorized: string;



  constructor(
    private integrationService: IntegrationService,
    private sanitizer: DomSanitizer,
    private authService: AuthService) {
   }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem(Constant.userData));
    this.userId = JSON.parse(localStorage.getItem(Constant.userId));
    this.isAuthorized = localStorage.getItem(Constant.authorization);
    this.loadMetabase();
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  loadMetabase() {
    const questionId = 5; 
    const userId = localStorage.getItem(Constant.userId); 
    this.integrationService.getMetabaseToken(questionId, userId).subscribe(token => {
      const urlMetabase = `https://analitica.yopresto.co/embed/question/${token}#bordered=true&titled=true`;
      this.metabaseUrl = this.getSafeUrl(urlMetabase);
      console.log(this.metabaseUrl); 

    });
  }

}
